import React from 'react';
import PropTypes from 'prop-types';

import Input from 'styled/Input';
import InputWrapper from './InputWrapper';

class DateTimeInput extends React.PureComponent {
  render() {
    return (
      <InputWrapper>
        <Input
          id={this.props.dateId}
          type="date"
          value={this.props.date}
          onChange={this.props.onChange}
          style={this.props.date ? { color: '#fff' } : undefined}
          min={this.props.min}
        />

        <Input
          id={this.props.timeId}
          type="time"
          value={this.props.time}
          onChange={this.props.onChange}
          disabled={!this.props.date}
          style={this.props.time ? { color: '#fff' } : undefined}
        />

        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13">
          <path d="M4 0v4H0v9h13V9h4V0H4zm0 12H1V9h3v3zm0-4H1V5h3v3zm4 4H5V9h3v3zm0-4H5V5h3v3zm0-4H5V1h3v3zm4 8H9V9h3v3zm0-4H9V5h3v3zm0-4H9V1h3v3zm4 4h-3V5h3v3zm0-4h-3V1h3v3z" fill="currentColor" fillRule="nonzero" />
        </svg>
      </InputWrapper>
    );
  }
}

DateTimeInput.propTypes = {
  onChange: PropTypes.func,
  dateId: PropTypes.string,
  timeId: PropTypes.string,
  date: PropTypes.string,
  time: PropTypes.string,
  min: PropTypes.string,
};

DateTimeInput.defaultProps = {
  onChange: () => {},
  dateId: '',
  timeId: '',
  date: '',
  time: '',
  min: '',
};

export default DateTimeInput;
